import { useState } from 'react';

export default function useAnimatedVisibility(duration = 300) {
  const [isVisible, setIsVisible] = useState(false);
  const [isHidden, setIsHidden] = useState(true);

  const show = () => {
    setIsHidden(false);
    requestAnimationFrame(() => {
      setIsVisible(true);
    });
  };

  const hide = () => {
    setIsVisible(false);
    setTimeout(() => setIsHidden(true), duration);
  };

  const toggle = () => {
    isVisible ? hide() : show();
  };

  return {
    isVisible,
    isHidden,
    show,
    hide,
    toggle,
  };
}
